import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, FormHelperText, Grid } from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import CustomTextField from "../../../components/Form/CustomTextField";
import InventoryVehicleDetailsSummaryModal from "../modal/InventoryVehicleDetailsSummary";
import SelectedVehicleSummary from "../modal/SelectedVehicleSummary";

const InventoryPricingInfo = ({ formObj, handleFormChange, handlePricingTypeDataChange, vehicle, windowWidth, isSingPass, error, bodyList, invType }) => {
    const [detailOpen, setDetailOpen] = React.useState(false);
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
    return (
        <React.Fragment>
            <SelectedVehicleSummary formObj={vehicle} setDetailOpen={setDetailOpen} />
            {
                invType === "rental" ?
                    <Box mt={4}>
                        <div className="text-semibold mb-2">Rental Rate</div>
                        <div className="subheader-2 mb-2">Please enter at least one rental rate (daily, 3-day, weekly, or monthly) before continuing.</div>
                        {error && error?.pricing_type && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.pricing_type || ""}</FormHelperText>}
                        <Grid container spacing={2}>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <CustomTextField
                                    title={'Daily Rate'}
                                    placeholder={'Daily Rate'}
                                    type={"number"}
                                    is2dp={true}
                                    values={formObj?.daily_rate}
                                    onChange={(e) => handleFormChange('daily_rate', e)}
                                    InputProps={{ startAdornment: '$' }}
                                    error={error?.daily_rate}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <CustomTextField
                                    title={'Weekend Rate'}
                                    placeholder={'Weekend Rate'}
                                    type={"number"}
                                    is2dp={true}
                                    values={formObj?.weekend_rate}
                                    onChange={(e) => handleFormChange('weekend_rate', e)}
                                    InputProps={{ startAdornment: '$' }}
                                    error={error?.weekend_rate}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <CustomTextField
                                    title={'3-day Rate'}
                                    placeholder={'3-day Rate'}
                                    type={"number"}
                                    is2dp={true}
                                    values={formObj?.three_day_rate}
                                    onChange={(e) => handleFormChange('three_day_rate', e)}
                                    InputProps={{ startAdornment: '$' }}
                                    error={error?.['3_days_rate']}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <CustomTextField
                                    title={'Weekly Rate'}
                                    placeholder={'Weekly Rate'}
                                    type={"number"}
                                    is2dp={true}
                                    values={formObj?.weekly_rate}
                                    onChange={(e) => handleFormChange('weekly_rate', e)}
                                    InputProps={{ startAdornment: '$' }}
                                    error={error?.weekly_rate}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <CustomTextField
                                    title={'Monthly Rate'}
                                    placeholder={'Monthly Rate'}
                                    type={"number"}
                                    is2dp={true}
                                    values={formObj?.monthly_rate}
                                    onChange={(e) => handleFormChange('monthly_rate', e)}
                                    InputProps={{ startAdornment: '$' }}
                                    error={error?.monthly_rate}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    :
                    <>
                        {
                            <Box mt={4}>
                                <div className="text-semibold">Pricing Details</div>
                                <Grid container spacing={2}>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <CustomTextField
                                            title={"Purchase Price"}
                                            type={'number'}
                                            is2dp={true}
                                            values={formObj?.purchase_price}
                                            onChange={(e) => handleFormChange('purchase_price', e)}
                                            InputProps={{ startAdornment: '$' }}
                                            error={error?.purchase_price}
                                        />
                                    </Grid>
                                    {invType !== "used" &&
                                        <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <CustomTextField
                                                title={"ARF"}
                                                type={'number'}
                                                is2dp={true}
                                                values={formObj?.arf}
                                                onChange={(e) => handleFormChange('arf', e)}
                                                InputProps={{ startAdornment: '$' }}
                                                error={error?.arf}
                                            />
                                        </Grid>}
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <CustomTextField
                                            title={"Suggested Price"}
                                            type={'number'}
                                            is2dp={true}
                                            values={formObj?.suggested_price}
                                            onChange={(e) => handleFormChange('suggested_price', e)}
                                            InputProps={{ startAdornment: '$' }}
                                            error={error?.suggested_price}
                                        />
                                    </Grid>

                                </Grid>
                            </Box>
                        }
                    </>
            }
            <InventoryVehicleDetailsSummaryModal
                open={detailOpen}
                close={() => setDetailOpen(false)}
                selectedVehicle={vehicle}
                isSingPass={isSingPass}
                invType={invType}
                windowWidth={windowWidth}
                bodyList={bodyList}

            />
        </React.Fragment>
    )
}

function mapStateToProps({ General, Advert }) {
    return {
        bodyList: General.bike_types,
        license_categories: General.license_categories,
        advertInterestRate: General.advertInterestRate,
        addAdvert: Advert.advertAdd,
        coeList: Advert.coeBiddingList,

    };
}

export default connect(mapStateToProps)(InventoryPricingInfo);